<template>
    <div class="layer mask50" v-show="visible">
        <div class="obtainCouponDialog"
             style="background: url('components/obtainCouponDialog/dialog_bg.svg') 0 bottom no-repeat;">
            <header>
                <i class="icon" style="width: 34px; height: 34px; background: url('icon/circle_black_close_icon.svg')"
                   @click="close()"></i>
            </header>
            <div class="body">
                <div class="title f_18r_bold_white alignC" style="padding: 35px 0;">恭喜！获得以下优惠券</div>
                <ul class="couponList hiddenScrollbar">
                    <li class="item clearfix"
                        style="background: url('components/obtainCouponDialog/coupon_bg.svg') no-repeat"
                        v-for="dataItem in dataList" :key="dataItem.id">
                        <div class="floatL alignC" style="width: 97px; padding-top: 10px;">
                            <div class="bold" style="color: #F92645;">
                                <span style="font-size: 13px;">￥</span>
                                <strong style="font-size: 32px;">{{ dataItem.creditAmount }}</strong>
                            </div>
                            <div class="f10" style="color: #FF3452">{{ dataItem.explain }}</div>
                        </div>
                        <div class="floatR" style="width: 130px; padding-top: 10px;">
                            <div class="f16 hiddenOverflow" style="color: #F92645; line-height: 22px; height: 22px;">
                                {{ dataItem.name }}
                            </div>
                            <div class="f10" style="color: #D82640">有效期为x天</div>
                        </div>
                    </li>
                </ul>

                <div class="alignC" style="padding-top: 50px;">

                    <template v-if="browserHelper.isWechat">

                        <wx-open-launch-app :username="externalApp.phoneApp.appId" extinfo="your-extinfo"
                                @launch="onLaunchWeApp" @error="onLaunchWeAppError">
                            <script type="text/wxtag-template">
                                <style>
                                    .goToUseButton {
                                        display: inline-block;
                                        width: 76px;
                                        height: 24px;
                                        line-height: 24px;
                                        border: 1px solid #FFFFFF;
                                        border-radius: 14px;
                                        color: white;
                                        font-size: 12px;
                                        text-align: center;
                                    }
                                </style>
                                <button class="goToUseButton"
                                        style="background: url('components/obtainCouponDialog/button.svg')"></button>
                            </script>
                        </wx-open-launch-app>

                    </template>

                    <template v-else>
                        <button class="goToUseButton"
                                style="background: url('components/obtainCouponDialog/button.svg')"
                                @click="ok()"></button>
                    </template>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import generalCmpPart from '@comp/part/generalCmpPart';

// data
// import couponBizTypeEnum    from '@/components/coupon/couponBizTypeEnum';
import externalApp from "@data/externalApp";

// platformApi
import requestManager from '@comp/platformApi/requestManager';

// util
import consoleHelper from '@util/consoleHelper';
import appHelper from '@util/appHelper';
import browserHelper from '@/util/browserHelper';
import deviceHelper from "@util/deviceHelper";
import consoleApi from "@comp/platformApi/consoleApi";

const config = {
    apiConfig: {
        list: {
            url: "portal/v4/go/getActivityCouponInfo"
        }
    }
};

export default {
    name: "obtainCouponDialog",
    extends: generalCmpPart,
    props: {
        onClose: Function,
        onOk: Function,
    },
    data() {
        return {
            apiConfig: config.apiConfig,
            enableDataList: true,
            // autoLoadDataList : true
            browserHelper,
            externalApp
        }
    },
    methods: {

        updateDataList(params = {}) {
            this.apiConfig.list.params = params;
            requestManager.request({
                url: this.apiConfig.list.url,
                method: this.apiConfig.list.method || 'get',
                params: this.apiConfig.list.params || {}
            }, (error, result) => {
                if (error) {
                    appHelper.showHint('获取优惠券时出错');
                    return;
                }

                /* error result {
                    data: null
                    errorCode: 1
                    msg: "您没有参与活动!"
                } */
                if (result.errorCode) {
                    consoleHelper.log('[obtainCouponDialog] ' + result.errorCode + ' ' + result.msg);
                    appHelper.showHint(result.errorCode + ' ' + result.msg);
                    return;
                }

                this.dataList = result.data;
                this.show();
            });
        },

        close: function () {
            this.visible = false;
            this.onClose ? this.onClose() : null;
        },

        ok: function () {
            this.visible = false;
            this.onOk ? this.onOk() : null;
        },
        onClickWeAppLink() {
            if (deviceHelper.isBrowser && !browserHelper.isWechat) {
                appHelper.showHint('只能在微信里面打开小程序');
            }
        },
        onLaunchWeApp(e) {
            consoleApi.log('launch weapp success', e);
        },
        onLaunchWeAppError(e) {
            consoleApi.log('launch weapp fail', e.detail);
        },
    }
}
</script>

<style lang="scss" scoped>
.obtainCouponDialog {
    height: 500px;
    position: absolute;
    z-index: 1;
    width: 315px;
    top: 50%;
    margin-top: -250px;
    left: 50%;
    margin-left: -157px;
}

.couponList {
    height: 218px;
    overflow: auto;

    .item {
        display: block;
        width: 245px;
        height: 64px;
        overflow: hidden;
        margin-bottom: 13px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.goToUseButton {
    width: 217px;
    height: 54px;
    border: none;
}
</style>
